module.exports = __webpack_public_path__ + "static/media/state-banner-3.33176530.png";